import { SectionSkeleton } from './components/section-skeleton';
import { TabsSkeleton } from './components/tabs-skeleton';

export const PresetsHomeSkeleton = () => {
  return (
    <div className='flex flex-col flex-1 overflow-hidden'>
      <div className='flex flex-col h-full pb-5 overflow-hidden overflow-y-auto scrollbar scrollbar-hide'>
        <div className='animate-pulse'>
          <header className='flex flex-col w-full flex-wrap py-5 pt-3 xs:pt-5 pb-6 sm:pb-8'>
            <div className='mb-4 xs:mb-6 px-4 xs:px-6 lg:px-10'>
              <div className='h-8 lg:h-10 w-32 bg-tertiary rounded-sm' />
            </div>
            <div className='flex items-start justify-between w-full gap-3 xs:px-6 lg:px-10'>
              <TabsSkeleton />
              <div className='hidden md:block h-9 w-36 bg-tertiary rounded-sm shrink-0' />
            </div>
          </header>
          <div className='px-4 xs:px-6 lg:px-10 space-y-12'>
            <SectionSkeleton cardCount={2} />
            <SectionSkeleton cardCount={3} />
            <SectionSkeleton cardCount={2} />
          </div>
        </div>
      </div>
    </div>
  );
};
